<template>
  <div>
    <el-dialog :title="dialogInfo.title[dialogInfo.type]"
               v-dialogDrag
               :fullscreen="fullscreen"
               :visible.sync="dialogInfo.visible"
               :width="dialogInfo.width"
               ref="fullscreen"
               :before-close="handleClose"
               @close="handleClick('close')">
      <div slot="title"
           style="padding:5px 0 5px">
        {{dialogInfo.title[dialogInfo.type]}}
        <el-button v-if="dialogInfo.fullscreen"
                   @click="bigscreen()"
                   class="button">
          <i v-show="!fullscreen"
             class="iconfont iconchuangkoufangda"></i>
          <i v-show="fullscreen"
             class="iconfont iconchuangkou"></i>
        </el-button>
        <el-button v-if="dialogInfo.switch"
                   @click="handleClick('switch')"
                   class="button">
          <i v-show="dialogInfo.formType==='one'"
             class="iconfont iconliebiao"
             style="font-size:14px"></i>
          <i v-show="dialogInfo.formType==='two'"
             class="el-icon-menu"></i>
        </el-button>
      </div>
      <slot></slot>
      <span v-if="dialogInfo.btList"
            slot="footer"
            class="dialog-footer">
        <el-button v-for="item of dialogInfo.btList"
                   :loading="item.loading"
                   :key="item.label"
                   :type="item.type"
                    v-show="item.show != null?item.show:true"
                   :icon="item.icon"
                   :style="item.style"
                   @click="handleClick(item.event)"
                   size="small">{{item.label}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BoyoDialog',
  props: {
    dialogInfo: Object
  },
  data () {
    return {
      fullscreen: false
    }
  },
  methods: {
    handleClose (done) {
      if (this.dialogInfo.type === 'title' || this.dialogInfo.type === 'qx') {
        done()
      } else {
        this.$confirm('关闭后当前表单数据将初始化,是否继续？', '提示', {
          type: 'warning'
        }).then(() => {
          done()
        })
      }
    },
    handleClick (event) {
      this.$emit('dialogEvent', event)
    },
    bigscreen () {
      this.fullscreen = !this.fullscreen
      this.$refs.fullscreen.style.top = 0
      this.$refs.fullscreen.style.left = 0
    }
  }
}
</script>
<style lang="stylus" scoped>
.button
  position absolute
  top 10px
  right 30px
  padding 0
  // background 0 0
  border none
  outline 0
  cursor pointer
  font-size 16px
</style>



// WEBPACK FOOTER //
// src/components/BoyoDialog/index.vue